import { ColumnLayout } from '@components/Layout/ColumnLayout/ColumnLayout';
import { useToggle } from '@hooks/useToggle';
import Drawer from '@mui/material/Drawer';
import { useExportDealers, useGetDealers } from '@services/api/dealers';
import { Outlet, useParams } from 'react-router-dom';
import { NewDealer } from './NewDealer';
import { LeftNavLinkTwoRows } from '@components/LeftNavLink/LeftNavLinkTwoRows';
import { useEffect, useState } from 'react';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ExportDropdown } from '@components/Dropdown/ExportDropdown';
import { UserTypeBaseRenderer } from '@components/helpers/UserTypeBaseRenderer';
import { AlertCenter } from '@components/AlertCenter/AlertCenter';

const DealersPageTitle = () => {
  const {
    translate,
    translations: {
      dealer: {
        list: { header, exportButton },
      },
    },
  } = useTranslations();

  const { exportDealers } = useExportDealers();

  return (
    <Stack direction="row" alignItems="center">
      <Typography ml={2} variant="h3">
        {translate(header)}
      </Typography>
      <UserTypeBaseRenderer include={[`Operation`]}>
        <ExportDropdown exportButtonText={translate(exportButton)} exportButtonAction={exportDealers} />
      </UserTypeBaseRenderer>
    </Stack>
  );
};

export const DealersPage = () => {
  const { dealerId } = useParams<{ dealerId: string }>();
  const { dealers } = useGetDealers();
  const [isNewDealerOpen, toggleIsNewDealerOpen] = useToggle();
  const [leftLink, setLeftLink] = useState<HTMLAnchorElement | null>(null);
  const [isFirstLoad, toggleIsFirstLoad] = useToggle(true);

  useEffect(() => {
    if (leftLink) {
      leftLink.scrollIntoView({ block: `center` });
      toggleIsFirstLoad();
      setLeftLink(null);
    }
    // watch only for leftLink
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftLink]);

  return (
    <ColumnLayout
      list={dealers.map(({ name, address, id }) => (
        <LeftNavLinkTwoRows
          key={id}
          title={name}
          href={`/dealers/${id}`}
          leftBottom={address.street}
          selected={String(id) === dealerId}
          ref={isFirstLoad && String(id) === dealerId ? setLeftLink : undefined}
        />
      ))}
      title={<DealersPageTitle />}
      titleComponents={<AlertCenter />}
      onNewClick={toggleIsNewDealerOpen}
      scrollBottomOnNewListElement
    >
      <Outlet />
      <Drawer open={isNewDealerOpen} onClose={toggleIsNewDealerOpen} anchor="right">
        <NewDealer onCancel={toggleIsNewDealerOpen} />
      </Drawer>
    </ColumnLayout>
  );
};
